import angular from 'angular';

import './workflow-table.style.scss';

import WorkflowTableController from './workflow-table.controller';

export default angular.module('autoboard.workflowTable', [])
  .controller('WorkflowTableController', WorkflowTableController)
  .name;
